import { useFormik } from 'formik';
import React, { useState } from 'react';
import InputBox from 'src/components/Common/InputBox/InputBox';
import TextWithIconButton from 'src/components/Common/TextWithIconButton';
import rightIcon from 'src/assets/svgs/rightIcon.svg';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { validation } from 'src/constants/general';
import { adminResetPassword } from 'src/services/admin';

function ResetPassword({ selectedRowData, setModalOpen, isOnSuccess }: any) {
    const [error, setError] = useState('');

    const onSubmit = async (values: any) => {
        try {
            const payload = {
                userId: selectedRowData.adminId,
                password: values.password,
            };
            const res = await adminResetPassword(payload);

            if (res.status && res.status === 200) {
                toast.success('Password reset successfully');
                setModalOpen(false);
                isOnSuccess();
            } else {
                setError(res.data.message);
            }
        } catch (err) {
            // console.log('Add hourly charge error:', err);
        } finally {
        }
    };

    const formik = useFormik({
        initialValues: {
            password: '',
            passwordConfirmation: '',
        },
        validationSchema: Yup.object({
            password: Yup.string().required('Please enter password').min(6, 'Password required minimum 6 characters'),
            passwordConfirmation: Yup.string()
                .required('Please enter confirm password')
                .oneOf([Yup.ref('password'), ''], 'Passwords must match'),
        }),
        onSubmit: onSubmit,
    });

    const handleSubmit = () => {
        formik.handleSubmit();
    };

    return (
        <div className="p-6 min-w-full">
            <div>
                <h1 className=" font-bold">Reset Password for {selectedRowData.adminFullName}</h1>
                {/* <h3 className=" mt-2">
                    {employDetail.name} {employDetail.surname}{' '}
                </h3> */}
            </div>
            <div className=" mt-4 flex gap-4 md:flex-row flex-col min-w-full">
                <div className=" w-full">
                    <InputBox
                        name={'password'}
                        type={'password'}
                        className="bg-gray10 border-none"
                        onChange={(e: any) => {
                            formik.handleChange(e);
                            setError('');
                        }}
                        // onBlur={formik.handleBlur}
                        inputId={'floating_filled_admin_5'}
                        value={formik.values.password}
                        placeholder="Enter Password"
                        error={formik.errors.password && formik.touched.password ? String(formik.errors.password) : ''}
                        maxLength={validation.password}
                    />
                </div>
            </div>
            <div className=" mt-4 flex gap-4 md:flex-row flex-col min-w-full">
                <div className="w-full">
                    <InputBox
                        name={'passwordConfirmation'}
                        type={'password'}
                        className="bg-gray10 border-none"
                        onChange={(e: any) => {
                            formik.handleChange(e);
                            setError('');
                        }}
                        // onBlur={formik.handleBlur}
                        inputId={'floating_filled_admin_3'}
                        value={formik.values.passwordConfirmation}
                        placeholder="Enter  Confirm Password"
                        error={formik.errors.passwordConfirmation && formik.touched.passwordConfirmation ? String(formik.errors.passwordConfirmation) : ''}
                        maxLength={validation.email}
                    />
                </div>
            </div>
            {error && <p className="text-red-600 mt-10 text-sm text-center">{error}</p>}
            <TextWithIconButton
                btnClassName={`w-46 h-12 px-6 mt-4 py-4 rounded-3xl  bg-secondary shadow justify-center items-center gap-2 inline-flex`}
                textClassName="text-white text-sm font-bold uppercase"
                imgClassName="w-6 h-6 relative"
                icon={rightIcon}
                textName={'Save'}
                altName="submit"
                onClick={handleSubmit}
                btnType="button"
            />
        </div>
    );
}

export default ResetPassword;
